import { render, staticRenderFns } from "./customselectCC.vue?vue&type=template&id=48cdf950"
import script from "./customselectCC.vue?vue&type=script&lang=js"
export * from "./customselectCC.vue?vue&type=script&lang=js"
import style0 from "./customselectCC.vue?vue&type=style&index=0&id=48cdf950&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports